// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"7b99fdd1","322":"7b99fdd1"}[chunkId] + ".chunk.css";
};